import { render, staticRenderFns } from "./AvitoAreasList.vue?vue&type=template&id=4451e9dd&"
import script from "./AvitoAreasList.vue?vue&type=script&lang=js&"
export * from "./AvitoAreasList.vue?vue&type=script&lang=js&"
import style0 from "./AvitoAreasList.vue?vue&type=style&index=0&id=4451e9dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports